(() => {
  const selector = '[data-mbb-destinations-hero]';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initHero = hero => {
    if (!hero || hero.dataset.mbbInitialized === 'true') return;

    hero.dataset.mbbInitialized = 'true';

    const image = hero.querySelector('.mbb-destinations-hero__image');
    const scrollButton = hero.querySelector('[data-mbb-scroll-next]');
    const enableParallax = hero.dataset.parallax === 'true';

    requestAnimationFrame(() => {
      hero.classList.add('is-visible');
    });

    if (enableParallax && image && !reduceMotion) {
      let ticking = false;

      const updateParallax = () => {
        const rect = hero.getBoundingClientRect();
        const progress = Math.max(-1, Math.min(1, -rect.top / rect.height));

        image.style.transform = `translate3d(0, ${progress * 28}px, 0) scale(1.04)`;
        ticking = false;
      };

      const onScroll = () => {
        if (!ticking) {
          requestAnimationFrame(updateParallax);
          ticking = true;
        }
      };

      updateParallax();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    scrollButton?.addEventListener('click', () => {
      hero.nextElementSibling?.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  };

  const initAll = root => {
    root.querySelectorAll(selector).forEach(initHero);
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => initAll(document))
    : initAll(document);

  document.addEventListener('shopify:section:load', event => {
    initAll(event.target);
  });
})();